import { toast } from "sonner"

import { COMMENT_ATTACHMENT_ACCEPT, commentAttachmentBatchError, commentAttachmentError } from "./attachment-rules"

export { COMMENT_ATTACHMENT_ACCEPT }

export function validateCommentAttachments(files: File[], existingCount: number): File[] {
  const batchError = commentAttachmentBatchError(files.length, existingCount)
  if (batchError) {
    toast.error(batchError)
    return []
  }

  return files.filter((file) => {
    const error = commentAttachmentError(file)
    if (error) {
      toast.error(error)
      return false
    }

    return true
  })
}
